module.exports = __webpack_public_path__ + "img/qiehuan.d55c965b.svg";